import { Navigate, Outlet } from "react-router-dom";

/**
 * ProtectedRoute
 * - Logged in (token exists)  → show the page
 * - Not logged in             → redirect to /login
 */
export default function ProtectedRoute() {
  const token = localStorage.getItem("token");
  return token ? <Outlet /> : <Navigate to="/login" replace />;
}
